import React, { FunctionComponent } from "react";
import { Dialog } from "@plex/react-components";
import { IViewController, useViewController } from "../ViewContext";
import { UserDefinedSchemasForm } from "./UserDefinedSchemasForm";
import "./UserDefinedSchemaEditor.scss";

export interface IUserDefinedSchemasEditorState {
  show: boolean;
  selectedSchemaId?: string;
  selectedSchemaName?: string;
  selectedSchemaInUse: boolean;
}

export interface IUserDefinedSchemasEditorProps {
  onClose?: () => void;
}

export const UserDefinedSchemasEditor: FunctionComponent<IUserDefinedSchemasEditorProps> = (props) => {
  const { userDefinedSchemasEditorState }: IViewController = useViewController();
  return (
    <Dialog show={userDefinedSchemasEditorState.show} onHide={props.onClose} title="User Defined Schemas">
      <div style={{ height: "auto" }}>
        <UserDefinedSchemasForm />
      </div>
    </Dialog>
  );
};
